// extracted by mini-css-extract-plugin
export default {"component":"OsLIGBazfwMSTXfLmXDo","componentOpen":"CnsrSKP5UPFxE4nOcwk9","description":"Bf5BNaEwvqpx2kcTpWlb","title":"GTpr9uFpL7JIwebC9irk"};